import { Dialog } from '@busybusy/webapp-react-ui';
import { DetailsItem } from 'components';
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import PositionDetailsBitwiseForm, { IPositionDetailsBitwiseFormProps } from '../forms/PositionDetailsBitwiseForm';
import { positionsValueString } from '../util/util';

export interface IPositionDetailsBitwiseDetailProps
  extends Omit<IPositionDetailsBitwiseFormProps, 'onSubmit' | 'subtitle'> {
  onUpdate: (value: number) => Promise<void>;
  editable: boolean;
  showDialogSubtitleAsHint?: boolean;
  dialogSubtitle?: string;
  requirePro?: boolean;
}

export default function PositionDetailsBitwiseDetail({
  title,
  currentValue,
  showDialogSubtitleAsHint = true,
  dialogSubtitle,
  onUpdate,
  editable,
  requirePro,
  ...formProps
}: IPositionDetailsBitwiseDetailProps) {
  const dialogDetails = useOpenable();
  const Component = requirePro ? ProDetailsItem : DetailsItem;

  function onSubmit(value: number) {
    onUpdate(value);
    dialogDetails.close();
  }

  return (
    <>
      <Component
        title={title}
        onClick={dialogDetails.open}
        value={positionsValueString(currentValue)}
        hint={showDialogSubtitleAsHint ? dialogSubtitle : undefined}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={dialogDetails.isOpen} onClose={dialogDetails.close}>
        <PositionDetailsBitwiseForm
          {...formProps}
          className="mt-4 p-8"
          title={title}
          currentValue={currentValue}
          onSubmit={onSubmit}
          subtitle={`${dialogSubtitle}`}
        />
      </Dialog>
    </>
  );
}
